import React from 'reactn'
import { GatsbyImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from 'gatsby-background-image'
import { useBreakpointValue } from '@chakra-ui/react'

export function GbiBridged({ imageData, mobileImageData, alt, eager, title }) {
  
  // const image = getImage(imageData)
  const mobileImage = mobileImageData ? mobileImageData : imageData
  const image = useBreakpointValue ([mobileImage, mobileImage, imageData, imageData])

  const bgImage = convertToBgImage(image)
  return (
    <BackgroundImage
      Tag="section"
      {...bgImage}
      preserveStackingContext
    >
        <GatsbyImage 
        loading={eager ? "eager" : "lazy"}
        image={image} 
        alt={alt}
        title={title ? title : alt}
        />
    </BackgroundImage>
  )
}
